import {
    ApprovalPurchaseOrderKind,
    ApproveEntityStatus,
    ApprovePurchaseOrderKind,
    PurchaseOrderStatus,
} from "@kase/my-marathon-communication";
import { ApproveFilter, ApprovePurchaseOrder, PurchaseOrder } from "~/core";

export const getApproveFilter = (company: string): ApproveFilter => ({
    companies: [company],
    statuses: [
        ApproveEntityStatus.ApproveOpen,
        ApproveEntityStatus.ApproveBooked,
    ],
    types: ["budget", "purchaseorder"],
});

export const getPurchaseApproval = (
    purchaseOrderId: string | null | undefined,
    orders: PurchaseOrder[],
    approves: ApprovePurchaseOrder[],
) => {
    const order = orders.find((o) => o._id.toString() === purchaseOrderId);
    const relevantApproves = approves.filter(
        (a) => a._id.toString() === purchaseOrderId,
    );
    const relevantApprovals = relevantApproves.flatMap(
        (a) => a.approvals.value,
    );
    const internalApprovals = relevantApprovals.filter(
        (a) =>
            a.approval_kind ===
            ApprovalPurchaseOrderKind.PurchaseOrderKindInternal,
    );
    const externalApprovals = relevantApprovals.filter(
        (a) =>
            a.approval_kind ===
            ApprovalPurchaseOrderKind.PurchaseOrderKindExternal,
    );
    const internalApproved =
        internalApprovals.length > 0 &&
        internalApprovals.every(
            (a) =>
                a.kind === ApprovePurchaseOrderKind.PurchaseOrderKindApproved,
        );
    const externalApproved =
        externalApprovals.length > 0 &&
        externalApprovals.every(
            (a) =>
                a.kind === ApprovePurchaseOrderKind.PurchaseOrderKindApproved,
        );
    const status = order?.status ?? PurchaseOrderStatus.PurchaseOrderStatusNone;

    return {
        status,
        approve: relevantApproves.at(0) ?? null,
        internal: {
            sent: status === PurchaseOrderStatus.PurchaseOrderStatusInternal,
            approved: internalApproved,
            approves: relevantApproves,
        },
        external: {
            sent: status === PurchaseOrderStatus.PurchaseOrderStatusExternal,
            approved: externalApproved,
        },
    };
};

export const getErrorMessage = (error: unknown, fallback = "Unknown error") =>
    error instanceof Error ? error.message : fallback;
